import { ReferenceRangeRiskLevel } from 'generated/types';

function determineLesionRiskLevel(lesionRisk: string): ReferenceRangeRiskLevel {
  switch (lesionRisk) {
    case 'high':
      return ReferenceRangeRiskLevel.high;
    case 'moderate':
      return ReferenceRangeRiskLevel.moderate;
    case 'low':
    default:
      return ReferenceRangeRiskLevel.normal;
  }
}

export { determineLesionRiskLevel };
